// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"581":"3032fb6c8de95a98","884":"0203f6afc204fbc8"}[chunkId] + ".js";
};